import * as yup from 'yup'

export const bankAccountSchema = yup
    .object({
        bankAccountName: yup
            .string()
            .trim()
            .required('Please enter account name')
            .min(2, 'Please enter a valid account name')
            .max(32, 'Cannot be more than 32 characters'),
        bsb: yup
            .string()
            .trim()
            .required('Please enter BSB')
            .min(6, 'Please enter a valid BSB')
            .max(7, 'Please enter a valid BSB')
            .matches(/^\d{3}[- ]?\d{3}$/, 'Please enter a valid BSB'),
        bankAccountNumber: yup
            .string()
            .trim()
            .required('Please enter account number')
            .matches(/^\d{6,10}$/, 'Please enter a valid bank account number'),
    })
    .required()

export type BankAccountFormValues = yup.InferType<typeof bankAccountSchema>
